import { prefix } from '../../utils/prefix';

const Url = {
  getWorkInfo: `${prefix}/info/worksInfo/get`,
  getInfo: `${prefix}/info/commitment/get`,
  save: `${prefix}/info/commitment/save`,
  saveDraft: `${prefix}/draft/commitment/save`,
  check: `${prefix}/info/worksInfo/check`,
};

export default Url;
